import { ReceiptModel } from '~app/shopping-cart/receipt/state/receipt.model';
import { AnnualDeclaration, AnnualDeclarationFormCollection } from '../model/annual-declaration.model';
import { AttachedDocuments } from '../model/company-identification.model';

export enum LoadFailStrategy {
  Init,
  DoNothing,
}

export class SaveAnnualDeclarationForm {
  static readonly type = '[AnnualDeclaration] SaveAnnualDeclarationForm';
  constructor(public annualDeclaration: AnnualDeclaration) { }
}

export class SaveAnnualDeclarationFormSuccess {
  static readonly type = '[AnnualDeclaration] SaveAnnualDeclarationFormSuccess';
  constructor() { }
}

export class SaveAnnualDeclarationFormFailure {
  static readonly type = '[AnnualDeclaration] SaveAnnualDeclarationFormFailure';
  constructor(public error: any) { }
}

export class LoadAnnualDeclarationForm {
  static readonly type = '[AnnualDeclaration] LoadAnnualDeclarationForm';
  constructor(public legalEntityId: string, public loadFailStrategy: LoadFailStrategy) { }
}

export class LoadAnnualDeclarationFormSuccess {
  static readonly type = '[AnnualDeclaration] LoadAnnualDeclarationFormSuccess';
  constructor(public legalEntityId, public formCollection: AnnualDeclarationFormCollection) { }
}

export class LoadAnnualDeclarationFormFailure {
  static readonly type = '[AnnualDeclaration] LoadAnnualDeclarationFormFailure';
  constructor(public legalEntityId: string) { }
}

export class LoadAnnualDeclarationFormMembers {
  static readonly type = '[AnnualDeclaration] LoadAnnualDeclarationFormMembers';
  constructor(public legalEntityId, public formCollection: AnnualDeclarationFormCollection) { }
}

export class LoadCompanyOtherEstablishmentFirebase {
  static readonly type = '[AnnualDeclaration] LoadAnnualDeclarationFormMembers';
  constructor(public legalEntityId) { }
}

export class InitAnnualDeclarationForm {
  static readonly type = '[AnnualDeclaration] InitAnnualDeclarationForm';
  constructor(public legalEntityId: string) { }
}

export class InitAnnualDeclarationFormSuccess {
  static readonly type = '[AnnualDeclaration] InitAnnualDeclarationFormSuccess';
  constructor(public legalEntityId: string) { }
}

export class InitAnnualDeclarationFormFailure {
  static readonly type = '[AnnualDeclaration] LoadAnnualDeclarationFormFailure';
  constructor(public error: any) { }
}

export class CompleteAnnualDeclarationForm {
  static readonly type = '[AnnualDeclaration] CompleteAnnualDeclarationForm';
  constructor(public paymentConfirmation?: ReceiptModel) { }
}

export class CompleteAnnualDeclarationFormSuccess {
  static readonly type = '[AnnualDeclaration] CompleteAnnualDeclarationFormSuccess';
  constructor(public legalEntityId: string) { }
}

export class CompleteAnnualDeclarationFormFailure {
  static readonly type = '[AnnualDeclaration] CompleteAnnualDeclarationFormFailure';
  constructor(public error: any) { }
}

export class GenerateAnnualDeclarationPdf {
  static readonly type = '[AnnualDeclaration] GenerateAnnualDeclarationPdf';
  constructor(public legalEntityId?: string) { }
}

export class GenerateAnnualDeclarationPdfSuccess {
  static readonly type = '[AnnualDeclaration] GenerateAnnualDeclarationPdfSuccess';
  constructor(public legalEntityId: string, public pdf: AttachedDocuments) { }
}

export class GenerateAnnualDeclarationPdfFailure {
  static readonly type = '[AnnualDeclaration] GenerateAnnualDeclarationPdfFailure';
  constructor(public legalEntityId, public error: any) { }
}

export class UploadDocument {
  static readonly type = '[AnnualDeclaration] UploadDocument';
  constructor(public legalEntityId: string, public type: string, public file: File) { }
}

export class UploadDocumentSuccess {
  static readonly type = '[AnnualDeclaration] UploadDocumentSuccess';
  constructor(public legalEntityId: string) { }
}

export class UploadDocumentFailure {
  static readonly type = '[AnnualDeclaration] UploadDocumentFailure';
  constructor(public error: any) { }
}

export class DeleteDocument {
  static readonly type = '[AnnualDeclaration] DeleteDocument';
  constructor(public legalEntityId: string, public documentId: string) { }
}

export class DeleteDocumentSuccess {
  static readonly type = '[AnnualDeclaration] DeleteDocumentSuccess';
  constructor(public legalEntityId: string) { }
}

export class DeleteDocumentFailure {
  static readonly type = '[AnnualDeclaration] DeleteDocumentFailure';
  constructor(public error: any) { }
}

export class SelectLegalEntity {
  static readonly type = '[AnnualDeclaration] SelectLegalEntity';
  constructor(public legalEntityId: string) { }
}

export class SelectLegalEntitySuccess {
  static readonly type = '[AnnualDeclaration] SelectLegalEntitySuccess';
  constructor(public legalEntityId: string) { }
}

export class SelectLegalEntityFailure {
  static readonly type = '[AnnualDeclaration] SelectLegalEntityFailure';
  constructor(public error: any) { }
}

export class CancelDocumentLoad {
  static readonly type = '[AnnualDeclaration] CancelDocumentLoad';
  constructor() { }
}

export class CancelDocumentLoadSuccess {
  static readonly type = '[AnnualDeclaration] CancelDocumentLoadSuccess';
  constructor() { }
}

export class CancelDocumentLoadFailure {
  static readonly type = '[AnnualDeclaration] CancelDocumentLoadFailure';
  constructor(public error: any) { }
}

export class DownloadSummary {
  static readonly type = '[AnnualDeclaration] DownloadSummary';
  constructor(public legalEntityId?: string) { }
}

export class DownloadSummarySuccess {
  static readonly type = '[AnnualDeclaration] DownloadSummarySuccess';
  constructor(public legalEntityId, public pdf) { }
}

export class DownloadSummaryFailure {
  static readonly type = '[AnnualDeclaration] DownloadSummaryFailure';
  constructor(public legalEntityId, public error: any) { }
}

export class LoadDeclarationYear {
  static readonly type = '[AnnualDeclaration] LoadDeclarationYear';
}

export class LoadDeclarationYearSuccess {
  static readonly type = '[AnnualDeclaration] LoadDeclarationYearSuccess';
  constructor(public year: number) { }
}

export class LoadDeclarationYearFailure {
  static readonly type = '[AnnualDeclaration] LoadDeclarationYearFailure';
  constructor(public error: any) { }
}

export class SetProcessingCompanySubscription {
  static readonly type = '[AnnualDeclaration] SetProcessingCompanySubscription';
  constructor(public processing: boolean) { }
}